import { ExportColumn } from '../../../interfaces/ExportColumn';

export const baseColumns: ExportColumn[] = [
  {
    key: 'name',
    header: 'Name',
    type: 'text',
    width: 45,
  },
  {
    key: 'supportedRevenue',
    header: 'Revenue Supported  Annually',
    type: 'money',
    width: 35,
  },
];
